import showEditor from './show-editor';
import hideEditor from './hide-editor';
import setLoadedStatus from './set-loaded-status';

export default {
  showEditor,
  setLoadedStatus,
  hideEditor,
};
